import {
  CameraInterfaceController,
  cameraInterfaceControllerSchema,
} from '@sophocles/entities/CameraInterfaceController/cameraInterfaceControllerRecord';
import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_CAMERA_INTERFACE_CONTROLLERS = 'RECEIVE_CAMERA_INTERFACE_CONTROLLERS';
export function receiveCameraInterfaceControllers(json) {
  return {
    type: RECEIVE_CAMERA_INTERFACE_CONTROLLERS,
    cameraInterfaceControllers: mapListToRecords(json, CameraInterfaceController),
  };
}

/* Request Actions */
// starter request
export const REQUEST_CAMERA_INTERFACE_CONTROLLER = 'REQUEST_CAMERA_INTERFACE_CONTROLLER';
function requestCameraInterfaceController(cameraInterfaceController_id) {
  return {
    type: REQUEST_CAMERA_INTERFACE_CONTROLLER,
    cameraInterfaceController_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchCameraInterfaceController(cameraInterfaceController_id) {
  return dispatch => {
    dispatch(requestCameraInterfaceController(cameraInterfaceController_id));
    return apiClient
      .get(`/camerainterfacecontrollers/${cameraInterfaceController_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'cameraInterfaceControllers', cameraInterfaceControllerSchema))
      .then(json => dispatch(receiveCameraInterfaceControllers(json.entities.cameraInterfaceControllers)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_CAMERA_INTERFACE_CONTROLLER)));
  };
}

/* Socket Delete Helper — kept for handleCameraInterfaceControllerSocketActions */
export const DELETE_CAMERA_INTERFACE_CONTROLLER = 'DELETE_CAMERA_INTERFACE_CONTROLLER';
function sayDeleteCameraInterfaceController(cameraInterfaceController_id) {
  return {
    type: DELETE_CAMERA_INTERFACE_CONTROLLER,
    cameraInterfaceController: cameraInterfaceController_id,
  };
}

const receiver = (dispatch, json) =>
  dispatch(receiveCameraInterfaceControllers(json.entities.cameraInterfaceControllers));

export const handleCameraInterfaceControllerSocketActions = websocketsHandlerFactory(
  receiver,
  sayDeleteCameraInterfaceController,
  cameraInterfaceControllerSchema,
);
